import { ControlType, FormField, FormFieldInit } from "./base";

const createInitialValues = (options: FormFieldCheckbox["options"]) => {
  const obj: { [key: string]: boolean } = {};

  options.forEach((item) => {
    const key = item.id;
    obj[key] = !!item.value;
  });
  return obj;
};

export class FormFieldCheckbox extends FormField {
  public override controlType = ControlType.CHECKBOX;
  declare initialValue?: object | undefined;

  public options: {
    id: string;
    label: string;
    isMarkdownLabel?: boolean;
    value?: boolean;
    disabled?: boolean;
    required?: boolean;
    urlSuffix?: UrlSuffix;
    testId?: string;
  }[];

  constructor(init: FormFieldInit<FormFieldCheckbox>) {
    super(init);
    this.options = init.options;
    this.initialValue = init.initialValue ?? createInitialValues(this.options);
  }
}

export interface UrlSuffix {
  text: string;
  url: string;
}
